import React from 'react';

export default function AnalyticsCard({ title, value, icon, onClick }) {
    return (
        <div onClick={onClick} className={`bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center transition-all duration-300 ${onClick ? 'cursor-pointer hover:shadow-md hover:scale-105' : ''}`}>
            <div className="bg-pink-50 text-pink-500 rounded-full h-14 w-14 flex items-center justify-center text-2xl flex-shrink-0">
                {icon}
            </div>
            <div className="ml-5 min-w-0">
                <p className="text-xs text-gray-500 font-bold uppercase tracking-wide mb-1 truncate">{title}</p>
                <p className="text-2xl font-extrabold text-gray-900 truncate" title={value}>{value}</p>
            </div>
        </div>
    );
}